export const RECEIVE_STUDENTS = 'EDUCATOR/RECEIVE_STUDENTS';
export const RECEIVE_RECENT_STUDENTS = 'EDUCATOR/RECEIVE_RECENT_STUDENTS';
export const REMOVE_STUDENT = 'EDUCATOR/REMOVE_STUDENT';
export const FETCH_STUDENTS_FOR_SEARCH = 'EDUCATOR/FETCH_STUDENTS_FOR_SEARCH';
export const UPDATE_STUDENT_SEARCH_OPTIONS = 'EDUCATOR/UPDATE_STUDENT_SEARCH_OPTIONS';
export const UPDATE_STUDENT_COUNTS = 'EDUCATOR/UPDATE_STUDENT_COUNTS';
export const RESET_STUDENT_SEARCH_OPTIONS = 'EDUCATOR/RESET_STUDENT_SEARCH_OPTIONS';
